import FormattedMessage from 'I18n/components/FormattedMessage';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { jsx as _jsx } from "react/jsx-runtime";
const SOURCE_APP_MESSAGES = {
  [SourceApps.ADS_FLOW]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.ADS_FLOW"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.ADS_FLOW"
    })
  },
  [SourceApps.ADVANCED_TICKET_SLAS]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.ADVANCED_TICKET_SLAS"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.ADVANCED_TICKET_SLAS"
    })
  },
  [SourceApps.CALLING_IVR_APP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.CALLING_IVR_APP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.CALLING_IVR_APP"
    })
  },
  [SourceApps.CMS_FORM_MODULE_FIELD]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.CMS_FORM_MODULE_FIELD"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.CMS_FORM_MODULE_FIELD"
    })
  },
  [SourceApps.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.CMS_FORM_MODULE_FIELD_FOLLOWUP_EMAIL"
    })
  },
  [SourceApps.CRM_MIGRATION]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.CRM_MIGRATION"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.CRM_MIGRATION"
    })
  },
  [SourceApps.CUSTOM_OBJECT_PIPELINE_SETTINGS]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.CUSTOM_OBJECT_PIPELINE_SETTINGS"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.CUSTOM_OBJECT_PIPELINE_SETTINGS"
    })
  },
  [SourceApps.DEAL_PIPELINE_SETTINGS]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.DEAL_PIPELINE_SETTINGS"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.DEAL_PIPELINE_SETTINGS"
    })
  },
  [SourceApps.DIRECT_API]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.DIRECT_API"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.DIRECT_API"
    })
  },
  [SourceApps.ECOMM]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.ECOMM"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.ECOMM"
    })
  },
  [SourceApps.EMBEDDED_QUOTES]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.EMBEDDED_QUOTES"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.EMBEDDED_QUOTES"
    })
  },
  [SourceApps.FEEDBACK]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FEEDBACK"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FEEDBACK"
    })
  },
  [SourceApps.FEEDBACK_FOLLOW_UP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FEEDBACK_FOLLOW_UP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FEEDBACK_FOLLOW_UP"
    })
  },
  [SourceApps.FORECASTING]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FORECASTING"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FORECASTING"
    })
  },
  [SourceApps.FORM_FIELD_FOLLOWUP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FORM_FIELD_FOLLOWUP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FORM_FIELD_FOLLOWUP"
    })
  },
  [SourceApps.FORM_FOLLOWUP_EMAIL]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FORM_FOLLOWUP_EMAIL"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FORM_FOLLOWUP_EMAIL"
    })
  },
  [SourceApps.FORMS_APP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.FORMS_APP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.FORMS_APP"
    })
  },
  [SourceApps.JOURNEY_STAGE]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.JOURNEY_STAGE"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.JOURNEY_STAGE"
    })
  },
  [SourceApps.LEAD_AUTOMATION_RULES]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.LEAD_AUTOMATION_RULES"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.LEAD_AUTOMATION_RULES"
    })
  },
  [SourceApps.LEAD_FLOW]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.LEAD_FLOW"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.LEAD_FLOW"
    })
  },
  [SourceApps.LEAD_FLOWS_APP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.LEAD_FLOWS_APP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.LEAD_FLOWS_APP"
    })
  },
  [SourceApps.LEAD_PIPELINE_SETTINGS]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.LEAD_PIPELINE_SETTINGS"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.LEAD_PIPELINE_SETTINGS"
    })
  },
  [SourceApps.MARKETING_EMAIL_AUTOMATED]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.MARKETING_EMAIL_AUTOMATED"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.MARKETING_EMAIL_AUTOMATED"
    })
  },
  [SourceApps.PUBLIC_API]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.PUBLIC_API"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.PUBLIC_API"
    })
  },
  [SourceApps.PUBLIC_FLOW_API]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.PUBLIC_FLOW_API"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.PUBLIC_FLOW_API"
    })
  },
  [SourceApps.RULESETS_PROSPECTING]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.RULESETS_PROSPECTING"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.RULESETS_PROSPECTING"
    })
  },
  [SourceApps.SEQUENCES_CONTEXTUAL_AUTOMATION]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.SEQUENCES_CONTEXTUAL_AUTOMATION"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.SEQUENCES_CONTEXTUAL_AUTOMATION"
    })
  },
  [SourceApps.SKILL_BASED_ROUTING]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.SKILL_BASED_ROUTING"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.SKILL_BASED_ROUTING"
    })
  },
  [SourceApps.TICKET_PIPELINE_SETTINGS]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.TICKET_PIPELINE_SETTINGS"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.TICKET_PIPELINE_SETTINGS"
    })
  },
  [SourceApps.TICKET_EMAIL_STATUS_SETTING]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.TICKET_EMAIL_STATUS_SETTING"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.TICKET_EMAIL_STATUS_SETTING"
    })
  },
  [SourceApps.WORKFLOWS_APP]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.WORKFLOWS_APP"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.WORKFLOWS_APP"
    })
  },
  [SourceApps.WORKFLOWS_CLASSIC]: {
    name: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.name.WORKFLOWS_CLASSIC"
    }),
    nameInPhrase: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-source-apps.nameInPhrase.WORKFLOWS_CLASSIC"
    })
  }
};
export { SOURCE_APP_MESSAGES };